module.exports = __webpack_public_path__ + "img/动态贴纸--个性定制gif.66ef6c59.gif";